import { getInAppBrowser } from '@/shared/lib/browser';
import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';

import { signupExperimentProperties } from './model';

type SignupPayload = Parameters<typeof MixpanelEvents.signUp>[0];

const inAppBrowserProperties = () => ({ in_app_browser: getInAppBrowser() ?? 'none' });

export const SignupExperimentEvents = {
  emailSignUpProceedClick: (properties?: SignupPayload) =>
    MixpanelEvents.emailSignUpProceedClick({ ...signupExperimentProperties(), ...inAppBrowserProperties(), ...properties }),
  signUp: (properties?: SignupPayload) =>
    MixpanelEvents.signUp({ ...signupExperimentProperties(), ...inAppBrowserProperties(), ...properties }),
  signUpPageShown: (properties?: SignupPayload) =>
    MixpanelEvents.signUpPageShown({ ...signupExperimentProperties(), ...inAppBrowserProperties(), ...properties }),
  signUpWithGoogleClick: (properties?: SignupPayload) =>
    MixpanelEvents.signUpWithGoogleClick({ ...signupExperimentProperties(), ...inAppBrowserProperties(), ...properties }),
  signUpWithSSOClick: (properties?: SignupPayload) =>
    MixpanelEvents.signUpWithSSOClick({ ...signupExperimentProperties(), ...inAppBrowserProperties(), ...properties }),
};
